import React from "react";
import { useParams } from "react-router-dom";

import DisciplineUpdatePage from "components/pages/ActivityDiscipline/DisciplineUpdate";

const DisciplineUpdate = () => {
  const { id } = useParams();

  return <DisciplineUpdatePage id={id} />;
};

export default DisciplineUpdate;
